import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import { INTERVIEW_TYPES } from '@/imports-files/common/common';
import {CommonAction} from '@/actions/common/common';
import Modal from "@/components/common-modal/modal";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";

export function InterviewListDetails(props)
{
  const data            = props.data;
  const candidate_names = data.attendant_list.filter( element => element.candidate);
  const interview_names = data.attendant_list.filter( element => !element.candidate);
  const commonAction    = new CommonAction();

  return (
  <Modal
    type="info"
      closeModal={() => props.setSingleEventDetails(false)}
      heading={`Interview Details`}
      className={`mt20`}
      innerContent={
        <div className={PageStyle.RequestDetails}>
         <h5>Stage Type: <span>{data.interview_type_name}</span></h5>

         <h5>Stage Name: <span>{data.stage_name}</span></h5>

         <h5>Date and Time: <span>{data.date} &nbsp; {data.time}</span></h5>

         {data.interview_link ? <h5>Interview Link: <span><a href={commonAction.embedHttps(data.interview_link)} target="_blank">{data.interview_link||'-'}</a></span></h5> : ''}

         {data.location ? <h5>Location Info: <span>{data.location || '-'}</span></h5> : ''}

         {data.job_title ? <h5>Job Title: <span>{data.job_title || '-'}</span></h5> : ''}

         {candidate_names ? <h5>Candidate Name: <span>{candidate_names.map((element, index) =>  { return( candidate_names.length - 1 == index  ? element.name : element.name+', ')} )}</span></h5> : ''}

         {(data.interview_type_name == INTERVIEW_TYPES.PHONE) && data.contact_no && <h5>Contact No: <span>{data.contact_no || '-'}</span></h5>}

         {interview_names ? <h5>Interviewer(s) Names: <span>{interview_names.map((element, index) =>  { return( interview_names.length - 1 == index  ? element.name : element.name+', ')} )}</span></h5> : ''}

      </div>
      }
      />
  )

}
